import sliderImg_1 from './img/heroSlider/61DUO0NqyyL._SX3000_.jpg';

import sliderImg_2 from './img/heroSlider/71qid7QFWJL._SX3000_.jpg';

import sliderImg_3 from './img/heroSlider/81d5OrWJAkL._SX3000_.jpg';

import sliderImg_4 from './img/heroSlider/71tIrZqybrL._SX3000_.jpg';

import sliderImg_5 from './img/heroSlider/61jovjd+f9L._SX3000_.jpg';

export const heroSlider = [
    {
        img: sliderImg_1
    },
    {
        img: sliderImg_2
    },
    {
        img: sliderImg_3
    },
    {
        img: sliderImg_4
    },
    {
        img: sliderImg_5
    },
]